import { Grid } from '@mui/material'
import { useEffect } from 'react'
import { UseFormReturn, useWatch } from 'react-hook-form'
import { ControlledTextField, AsyncSelect } from 'src/components/forms'
import { SectionBox } from 'src/pages/sistema/components/FieldView'
import { OperacionCFFields } from '../types/fields'
import CardActions from '../../../components/CardActions'
import { OpcionSiNo, useSiNoOptions } from '../../adcm/hooks/useOpcionesGenericas'

interface SeccionNuevoCFDetalleTransaccionProps {
  formMethods: UseFormReturn<any>
}

const SeccionNuevoCFDetalleTransaccion = ({ formMethods }: SeccionNuevoCFDetalleTransaccionProps) => {
  const { control, setValue, trigger } = formMethods
  const loadSiNo = useSiNoOptions()




  return (
    <CardActions title='Detalle de la Transacción' icon='mdi:file-document-edit-outline' colapsable>
      <SectionBox>
        {/* Fila 1: Razón Social y Tipo de Cliente */}
        
        

       
        {/* Fila 2: Campos de Success Fee y Retainer */}
        <Grid item xs={12} >
          <ControlledTextField
            label='Success fee (%)'
            name={OperacionCFFields.SuccessFee}
            control={control}
            fullWidth
          />
        </Grid>
        <Grid item xs={12} >
          <ControlledTextField
            label='Monto mínimo success (USD)'
            name={OperacionCFFields.MontoMinimoSuccess}
            control={control}
            fullWidth
          />
        </Grid>
        <Grid item xs={12} >
          <ControlledTextField
            label='Meses de retainer'
            name={OperacionCFFields.CantMesesRetainer}
            control={control}
            fullWidth
          />
        </Grid>
        <Grid item xs={12} >
          <ControlledTextField
            label='Monto retainer mensual (USD)'
            name={OperacionCFFields.MontoRetainerMensual}
            control={control}
            fullWidth
          />
        </Grid>

        {/* Fila 3: Desplegables Sí/No usando useSiNoOptions */}
        <Grid item xs={6} md={4}>
          <AsyncSelect
            label='Acreditación de retainer mensual'
            name={OperacionCFFields.AcreditacionRetainerMensual}
            loadOptions={loadSiNo}
            control={control}
            fullWidth
            selectNotNulleable
          />
        </Grid>
        <Grid item xs={6} md={4}>
          <AsyncSelect
            label='Exclusividad'
            name={OperacionCFFields.Exclusividad}
            loadOptions={loadSiNo}
            control={control}
            fullWidth
            selectNotNulleable
          />
        </Grid>
      </SectionBox>
    </CardActions>
  )
}

export default SeccionNuevoCFDetalleTransaccion